import { render, staticRenderFns } from "./leave-message.vue?vue&type=template&id=697eab0a&"
import script from "./leave-message.vue?vue&type=script&lang=js&"
export * from "./leave-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports